import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'

import { useHandlers } from './hooks'
import { useReferralsContext } from '@user/components/Referrals/context'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'
import FormHelperText from '@mui/material/FormHelperText'
import { Theme } from '@mui/material/styles'

const maxLength = 50
const inputProps = { maxLength: maxLength }

export function TidalOtherContent(props: ReferralFormProps) {
  const { handleOtherChange, isInValid, error } = useHandlers(props)
  const [{ referralOther }] = useReferralsContext()
  const helperText = `${referralOther.length ?? 0}/${maxLength}`

  return (
    <Box>
      <Typography
        variant="body1"
        sx={{
          color: (theme: Theme) => theme.palette.text.secondary,
        }}
      >
        Add Other
      </Typography>
      <Typography variant="body2" pb={'12px'}>
        Will not transfer upon Location Match / Creation
      </Typography>
      <TextField
        label="Other"
        required
        fullWidth
        onChange={handleOtherChange}
        inputProps={inputProps}
        value={referralOther}
        data-test-id="other-input"
        error={isInValid}
      />

      {!isInValid && (
        <Typography ml={1.8} variant={'caption'}>
          {helperText}
        </Typography>
      )}
      {isInValid && (
        <FormHelperText sx={{ ml: 1 }} error>
          {error}
        </FormHelperText>
      )}
    </Box>
  )
}
